// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-a039a438]:root{--light_text_color:#666}.line-item-summary__item td[data-v-a039a438],.line-item-summary__item th[data-v-a039a438]{font-size:15px;text-align:right;padding-bottom:5px}.line-item-summary__item th[data-v-a039a438]{color:#a2a2a6;padding:0 5px 0 0;font-weight:400}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
